<template>
  <div>
    <top-bar title="Notificações"/>
    <div class="mx-auto" style="max-width: 400px">
      <div class="container mt-3" v-if="!load">
        <h6 class="mb-4 font-weight-normal">Como quer receber os alertas de alteração de status dos pedidos, avisos, novidades e promoções?</h6>
        <div v-for="n in notifications">
          <div class="d-flex justify-content-between align-items-center py-3 border-top">
            <h6 class="m-0">{{ n.nome }}</h6>
            <div class="px-2" v-if="n.ativado">
              <a class="text-primary text-decoration-none" href="javascript:" @click="togglePush(n)">
                <svg xmlns="http://www.w3.org/2000/svg" height="42px" width="42px" viewBox="0 -107 512 512" v-if="n.habilitado"><path d="m0 149.332031c0 82.347657 67.007812 149.335938 149.332031 149.335938h213.335938c82.324219 0 149.332031-66.988281 149.332031-149.335938 0-82.34375-67.007812-149.332031-149.332031-149.332031h-213.335938c-82.324219 0-149.332031 66.988281-149.332031 149.332031zm0 0" fill="#11b982"/><path d="m448 149.332031c0 47.128907-38.203125 85.335938-85.332031 85.335938-47.128907 0-85.335938-38.207031-85.335938-85.335938 0-47.128906 38.207031-85.332031 85.335938-85.332031 47.128906 0 85.332031 38.203125 85.332031 85.332031zm0 0" fill="#fafafa"/></svg>
                <svg xmlns="http://www.w3.org/2000/svg" height="42px" width="42px" viewBox="0 -107 512 512" v-else><g><path d="m362.667969 0h-213.335938c-82.324219 0-149.332031 66.988281-149.332031 149.332031 0 82.347657 67.007812 149.335938 149.332031 149.335938h213.335938c82.324219 0 149.332031-66.988281 149.332031-149.335938 0-82.34375-67.007812-149.332031-149.332031-149.332031zm0 0" fill="#607d8b"/><path d="m234.667969 149.332031c0 47.128907-38.207031 85.335938-85.335938 85.335938-47.128906 0-85.332031-38.207031-85.332031-85.335938 0-47.128906 38.203125-85.332031 85.332031-85.332031 47.128907 0 85.335938 38.203125 85.335938 85.332031zm0 0" fill="#fafafa" data-original="#FAFAFA" class="active-path" style="fill:#FAFAFA"/></g> </svg>
              </a>
            </div>
          </div>
          <aviso-informativo variante="amarelo" class="small mb-3" v-if="!n.ativado">
            No momento esta funcionalidade ainda não está disponível neste dispositivo.
          </aviso-informativo>
        </div>
      </div>
      <loading v-else/>
    </div>
  </div>
</template>

<script>
import AvisoInformativo from "../components/AvisoInformativo";
  import Loading from "../components/Loading";
  import TopBar from "../components/TopBar";
  export default {
    name: 'Notificacao',
    components: {AvisoInformativo, TopBar, Loading},
    data() {
      return {
        load: true,
        token: localStorage.getItem('token'),
        notifications: [
          {
            tipo: 1,
            nome: "Notificações Push",
            ativado: false,
            habilitado: false
          },
          {
            tipo: 2,
            nome: "WhatsApp",
            ativado: false,
            habilitado: false
          }
        ]
      }
    },

    methods: {
      voltar() {
        if (this.menu) {
          this.menu = 0;

        } else {
          this.$router.go(-1)
        }
      },

      togglePush(notificacao) {
        switch (notificacao.tipo) {
          case 1:
            if (!notificacao.habilitado) {
              this.$store.state.modalPush = this.$store.state.modalPush + 1;

            } else {
              this.alterarNotificacoes(notificacao, false);
            }

            break;

          case 2:
            this.alterarNotificacoes(notificacao, notificacao.habilitado ? '0' : '1');
            break;
        }
      },

      alterarNotificacoes(notificacao, ativar) {
        this.$swal({
          text: `Deseja ${ativar === '1' ? 'ativar' : 'desativar' } esta notificação?`,
          buttons: ["Não", "Sim"],
          dangerMode: true
        }).then((res) => {
          if (res) {
            this.load = true;

            let dados = {
              push_habilitado: notificacao.tipo === 1 ? ativar : this.notifications[0].habilitado ? '1' : '0',
              wpp_habilitado: notificacao.tipo === 2 ? ativar : this.notifications[1].habilitado ? '1' : '0'
            }

            this.$http.post(this.empresa.token + '/' + this.token + '/cliente/notificacoes', dados).then(res => {
              if (res.data.success) {

                if (!dados.push_habilitado) {
                  this.$OneSignal.setSubscription(false).then(() => {
                    window.location.href = this.$route.path;
                  });

                } else {
                  window.location.href = this.$route.path;
                }

              } else {
                this.load = false;
                this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro ao alterar esta notificação');
              }

            }, (res) => {
              this.load = false;
              this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro ao alterar esta notificação');
            });
          }
        })
      }
    },

    mounted() {
      if (this.oneSignalIntegration && !this.isInstagram) {
        this.notifications[0].ativado = true;
        this.$OneSignal.isPushNotificationsEnabled().then(isPushEnabled => {
          this.load = false;
          this.notifications[0].habilitado = isPushEnabled;
        });

      } else {
        this.load = false;
      }

      this.notifications[1].ativado = !!this.token;
      this.notifications[1].habilitado = this.usuario.wpp_habilitado === '1';
    },

    computed: {
      usuario() {
        return this.$store.state.dataUser
      },

      empresa() {
        return this.$store.state.empresa
      }
    }
  }
</script>

<style scoped>
</style>
